<template>
  <el-card
    shadow="never"
    :body-style="{
      padding: '20px 15px',
    }"
  >
    <div v-if="!isEmpty">
      <div style="font-size: 14px; color: #101010">{{ '产品相关图片' }}</div>
      <div style="font-size: 12px; color: #8f97ad">
        {{ '业务人员上传的关于该产品的图片' }}
      </div>
      <div class="desc_body_class d-flex" v-viewer="{ movable: true }">
        <div
          v-for="(content, i) in trackingImageList"
          :key="i"
          class="desc_body-item"
        >
          <div class="mt-3">
            <div class="desc_body-item__image">
              <img
                :src="content.originImageUrl"
                style="width: 180px; height: 120px; object-fit: cover"
                fit="cover"
                @click="onPreview"
              />
            </div>
            <div class="image_text">Sent at 2024-01-10 10:10:30</div>
            <div class="executor">
              <img
                v-if="content.avatar"
                :src="content.avatar"
                class="description_avatar"
              />
              <span v-if="!content.avatar" class="description_avatar"> U </span>
              <span> {{ content.tskByName }}</span>
            </div>
          </div>
        </div>
      </div>
      <div style="font-size: 14px; color: #101010">
        {{ '产品相关文档' }}
      </div>
      <div style="font-size: 12px; color: #8f97ad">
        {{ '业务人员上传的关于该产品的相关文档' }}
      </div>
      <div class="file_body_class">
        <div
          v-for="(content, i) in trackingFileList"
          :key="i"
          class="file_body_item"
        >
          <div class="">
            <div class="cust_wrapper">
              <el-avatar
                shape="square"
                :src="content.custFileIcon"
                :class="{ 'bg-transparent': content.custFileIcon }"
                style="width: 40px; height: 40px; margin-right: 15px"
              />
              <div>
                <div class="file_name_class">
                  <el-tooltip
                    class=""
                    effect="dark"
                    :content="content.fileName"
                    :disabled="isShowTooltip"
                    placement="top"
                  >
                    <span
                      :ref="content.fileCode"
                      @mouseover="onMouseOver(content.fileCode)"
                      >{{ content.fileName }}</span
                    >
                  </el-tooltip>
                </div>
                <div
                  style="font-size: 12px"
                  class="d-flex justify-content-between align-items-center"
                >
                  <div>
                    <span style="color: #8e8e8e">SIZE：</span>
                    <span style="color: #6c757d; font-weight: 600">
                      {{ content.fileSize }}</span
                    >
                  </div>
                  <div>
                    <span style="color: #8e8e8e">Upload：</span>
                    <span style="color: #6c757d; font-weight: 600">
                      {{ content.fileTime }}</span
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex">
              <div class="delete_button">
                <div style="text-align: center; color: #bbbbbb" class="wh-30">
                  <i class="el-icon-delete icon_button"></i>
                </div>
              </div>

              <div
                class="d-flex justify-content-between align-items-center flex-1"
                style="line-height: 40px"
              >
                <div class="executor">
                  <span style="font-size: 12px; color: #8f97ad">
                    {{ 'Upload by：' }}</span
                  >
                  <img
                    v-if="content.avatar"
                    :src="content.avatar"
                    class="description_avatar"
                  />
                  <span v-if="!content.avatar" class="description_avatar">
                    U
                  </span>
                  <span
                    style="color: #6c757d; font-weight: 600; font-size: 12px"
                  >
                    {{ content.tskByName }}</span
                  >
                </div>
                <div
                  style="text-align: center; color: #bbbbbb"
                  class="icon__wrapper"
                >
                  <div @click="viewFile(content)" class="wh-30">
                    <i class="el-icon-view icon_button"></i>
                  </div>
                  <div class="ml-2 wh-30" @click="downloadFile(content)">
                    <i class="el-icon-download icon_button"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="not-data__container">
      <div style="text-align: center">
        <img src="/image/static/img/nodata.png" />
        <p class="no-data mt-2">
          {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
        </p>
      </div>
    </div>
  </el-card>
</template>
<script>
import { request } from '@/api/service'
export default {
  components: {},
  props: {
    devTrackingCode: { log: String, default: '' },
  },
  data() {
    return {
      trackingImageList: [
        {
          originImageCode: 'publicfiles--67277e28e4ae7a517234da6191d509a7.jpg',
          originImageSpec: '1518×1730',
          originImageUrl:
            'https://abs-oss.oss-cn-shanghai.aliyuncs.com/202312%2F67277e28e4ae7a517234da6191d509a7.jpg',
          thumbImageCode: 'publicfiles--748f5707cf22235e7b44b8a0b61cc582.jpg',
          thumbImageSpec: '960×640',
          thumbImageUrl:
            'https://abs-oss.oss-cn-shanghai.aliyuncs.com/202312%2F748f5707cf22235e7b44b8a0b61cc582.jpg',
          tskByName: '无名',
        },
        {
          originImageCode: 'publicfiles--03d5d096847cb9707f7548f976783f55.jpg',
          originImageSpec: '1484×1682',
          originImageUrl:
            'https://abs-oss.oss-cn-shanghai.aliyuncs.com/202312%2F03d5d096847cb9707f7548f976783f55.jpg',
          thumbImageCode: 'publicfiles--cb256808c8899aaacb5ab4084440a171.jpg',
          thumbImageSpec: '960×640',
          thumbImageUrl:
            'https://abs-oss.oss-cn-shanghai.aliyuncs.com/202312%2Fcb256808c8899aaacb5ab4084440a171.jpg',
          tskByName: '无名',
        },
        {
          originImageCode: 'publicfiles--d2579094e655a6f7eae0417a66818e5b.jpg',
          originImageSpec: '2472×2332',
          originImageUrl:
            'https://abs-oss.oss-cn-shanghai.aliyuncs.com/202312%2Fd2579094e655a6f7eae0417a66818e5b.jpg',
          thumbImageCode: 'publicfiles--0a37fe02c8d12d63aa7845010ba63fc2.jpg',
          thumbImageSpec: '960×640',
          thumbImageUrl:
            'https://abs-oss.oss-cn-shanghai.aliyuncs.com/202312%2F0a37fe02c8d12d63aa7845010ba63fc2.jpg',
          tskByName: '无名',
        },
        {
          originImageCode: 'publicfiles--d2579094e655a6f7eae0417a66818e5b.jpg',
          originImageSpec: '2472×2332',
          originImageUrl:
            'https://abs-oss.oss-cn-shanghai.aliyuncs.com/202312%2Fd2579094e655a6f7eae0417a66818e5b.jpg',
          thumbImageCode: 'publicfiles--0a37fe02c8d12d63aa7845010ba63fc2.jpg',
          thumbImageSpec: '960×640',
          thumbImageUrl:
            'https://abs-oss.oss-cn-shanghai.aliyuncs.com/202312%2F0a37fe02c8d12d63aa7845010ba63fc2.jpg',
          tskByName: '无名',
        },
        {
          originImageCode: 'publicfiles--d2579094e655a6f7eae0417a66818e5b.jpg',
          originImageSpec: '2472×2332',
          originImageUrl:
            'https://abs-oss.oss-cn-shanghai.aliyuncs.com/202312%2Fd2579094e655a6f7eae0417a66818e5b.jpg',
          thumbImageCode: 'publicfiles--0a37fe02c8d12d63aa7845010ba63fc2.jpg',
          thumbImageSpec: '960×640',
          thumbImageUrl:
            'https://abs-oss.oss-cn-shanghai.aliyuncs.com/202312%2F0a37fe02c8d12d63aa7845010ba63fc2.jpg',
          tskByName: '无名',
        },
        {
          originImageCode: 'publicfiles--d2579094e655a6f7eae0417a66818e5b.jpg',
          originImageSpec: '2472×2332',
          originImageUrl:
            'https://abs-oss.oss-cn-shanghai.aliyuncs.com/202312%2Fd2579094e655a6f7eae0417a66818e5b.jpg',
          thumbImageCode: 'publicfiles--0a37fe02c8d12d63aa7845010ba63fc2.jpg',
          thumbImageSpec: '960×640',
          thumbImageUrl:
            'https://abs-oss.oss-cn-shanghai.aliyuncs.com/202312%2F0a37fe02c8d12d63aa7845010ba63fc2.jpg',
          tskByName: '无名',
        },
        {
          originImageCode: 'publicfiles--d2579094e655a6f7eae0417a66818e5b.jpg',
          originImageSpec: '2472×2332',
          originImageUrl:
            'https://abs-oss.oss-cn-shanghai.aliyuncs.com/202312%2Fd2579094e655a6f7eae0417a66818e5b.jpg',
          thumbImageCode: 'publicfiles--0a37fe02c8d12d63aa7845010ba63fc2.jpg',
          thumbImageSpec: '960×640',
          thumbImageUrl:
            'https://abs-oss.oss-cn-shanghai.aliyuncs.com/202312%2F0a37fe02c8d12d63aa7845010ba63fc2.jpg',
          tskByName: '无名',
        },
        {
          originImageCode: 'publicfiles--d2579094e655a6f7eae0417a66818e5b.jpg',
          originImageSpec: '2472×2332',
          originImageUrl:
            'https://abs-oss.oss-cn-shanghai.aliyuncs.com/202312%2Fd2579094e655a6f7eae0417a66818e5b.jpg',
          thumbImageCode: 'publicfiles--0a37fe02c8d12d63aa7845010ba63fc2.jpg',
          thumbImageSpec: '960×640',
          thumbImageUrl:
            'https://abs-oss.oss-cn-shanghai.aliyuncs.com/202312%2F0a37fe02c8d12d63aa7845010ba63fc2.jpg',
          tskByName: '无名',
        },
      ],
      trackingFileList: [],
      fileList: [],
      fileIcons: {},
      isShowTooltip: true,
    }
  },
  mounted() {
    this.getData()
  },
  computed: {
    isEmpty() {
      return (
        (!this.trackingImageList || !this.trackingImageList.length) &&
        (!this.trackingFileList || !this.trackingFileList.length)
      )
    },
  },
  watch: {
    fileList: {
      handler(e) {
        if (!e || !e.length) return
        this.getFileIcons()
      },
      immediate: true,
    },
  },

  methods: {
    getData() {
      if (!this.devTrackingCode) return
      // this.loading = true
      // this.$api
      //   .mastetApi({
      //     devTrackingCode: this.devTrackingCode,
      //   })
      //   .then((res) => {
      //     this.loading = false
      //     this.trackingFileList = res.body.data || []
      //     this.fileList = res.body.data || []
      //   })
      //   .catch(() => {
      //     this.loading = false
      //   })
      this.trackingFileList = [
        {
          fileSize: '3.8 M',
          fileType: 'xlsx',
          fileTime: '2024-01-10 10:10:30',
          tskByName: '无名',
          fileCode: 'publicfiles--5b45dee5f3e609d56f91a0ff03f38f3b.xlsx',
          fileName: 'NC赋码文件_1705477510327.xlsx',
          fileUrl:
            'https://abs-oss.oss-cn-shanghai.aliyuncs.com/202401/5b45dee5f3e609d56f91a0ff03f38f3b.xlsx?Expires=2021536860&OSSAccessKeyId=LTAI4G9GTRRdivUVG4GXBpXM&Signature=w6AlbIlCFmiMqcvH1e0%2Buv7B0Fw%3D',
        },
        {
          fileSize: '3.8 M',
          fileType: 'pdf',
          fileTime: '2024-01-10 10:10:30',
          tskByName: '无名',
          fileCode: 'publicfiles--3cd79b241516390d31563b25493056fe.pdf',
          fileName: '面料开发申请单20240115165520.pdf',
          fileUrl:
            'https://abs-oss.oss-cn-shanghai.aliyuncs.com/202401/3cd79b241516390d31563b25493056fe.pdf?Expires=2021537010&OSSAccessKeyId=LTAI4G9GTRRdivUVG4GXBpXM&Signature=rXduVJybgWoAP6DyUnLqdXQ%2FnDw%3D',
        },
        {
          fileCode: 'd1e3cd7d9eee734f9cc9996d12273caa.xlsx',
          fileName: 'ASDA-jumbo 和velvet 价格及整体情况分析-2023-10-20.xlsx',
          fileSize: '3.8 M',
          fileType: 'xlsx',
          fileTime: '2024-01-10 10:10:30',
          tskByName: '无名',
        },
      ]
      this.fileList = [{}]
    },
    onMouseOver(event) {
      const tag = this.$refs[event]
      const parentWidth = tag[0].parentNode.offsetWidth
      const contentWidth = tag[0].offsetWidth
      this.isShowTooltip = contentWidth <= parentWidth
    },
    async getFileIcons() {
      const res = await request({
        url: '/sys/common/dict/system',
        method: 'POST',
        data: { dictType: 'FileTypeIcon' },
      }).catch(() => null)

      const data = res?.body?.data || []
      this.fileIcons = Object.fromEntries(
        data.map(({ value, label }) => [value, label])
      )
      this.trackingFileList = this.trackingFileList.map((t) => {
        t.custFileIcon = this.getFileIcon(t.fileType)
        return t
      })
      console.log('this.trackingFileList', this.trackingFileList)
    },
    getFileIcon(fileType) {
      return this.$osscdn(
        this.fileIcons[fileType.toUpperCase()] || this.fileIcons['OTHER']
      )
    },
    onPreview(index) {
      const viewer = this.$el.querySelector('.desc_body_class').$viewer
      viewer.view(index)
      viewer.show()
    },
    downloadFile({ fileCode = '' }) {
      this.$api.SYS_FILEDOWNLOAD(fileCode)
    },
    viewFile({ fileCode }) {
      this.$api.SYS_FILEDOWNLOAD(fileCode, { isAutoDown: true, preview: true })
    },
  },
}
</script>
<style lang="scss" scoped>
.desc_body_class {
  flex-wrap: wrap;
  border: 1px #bbbbbb dashed;
  padding: 0px 5px 15px 5px;
  margin: 12px 0px;
  border-radius: 5px;
}

.desc_body-item {
  margin-left: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.desc_body-item__image {
  background-color: rgba(244, 246, 249, 1);
  border-radius: 5px;
  padding: 5px;
}

.file_body_class {
  display: flex;
  flex-wrap: wrap;
  margin: 12px 0px;
}

.file_body_item {
  width: 380px;
  height: 94px;
  border: 1px #bbbbbb dashed;
  margin: 0px 10px 10px 0px;
  padding: 10px;
  border-radius: 5px;
  .cust_wrapper {
    display: flex;
  }
}

.image_text {
  color: #8e8e8e;
  font-size: 12px;
}

.executor {
  font-size: 14px;
  color: #303133;
  .description_avatar {
    display: inline-block;
    width: 24px;
    height: 24px;
    line-height: 24px;
    text-align: center;
    border-radius: 50%;
    background-color: #cccccc;
    color: #fff;
    font-size: 14px;
    cursor: default;
    margin-left: auto;
  }
}
.file_name_class {
  font-size: 14px;
  color: #007bff;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 290px;
}

.not-data__container {
  height: 500px;
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;
}
.delete_button {
  width: 40px;
  height: 40px;
  margin-right: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.wh-30 {
  width: 30px;
  height: 30px;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.icon__wrapper {
  display: flex;
  div {
    display: flex;
    align-items: center;
  }
}
.flex-1 {
  flex: 1;
}
.icon_button {
  font-size: 18px;
  cursor: pointer;
}
.wh-30:hover {
  background-color: #ecf5ff;
}
.icon_button:hover {
  color: #307af9;
  background-color: #ecf5ff;
}
</style>
